import {
  Dimension
} from './dimension';
import {
  Cube
} from './cube';
import {
  Filter
} from './filter';
import {
  WEEKDAYS
} from './datetime';
import {
  PATH_STRING_SEPARATOR
} from './config';

const DIALOG_DIRECTIONS = {
  'Incoming': gettext('Входящие'),
  'Outgoing': gettext('Исходящие'),
};

/* OLAP cubes models */
export class Model {

  // constructor() {
  // }

  buildModel() {
    $(this.dimensions).each(function(idx, dimension) {
      Object.setPrototypeOf(dimension, Dimension.prototype);
      dimension.buildModel();
    });
    $(this.cubes).each(function(idx, cube) {
      Object.setPrototypeOf(cube, Cube.prototype);
      cube.buildModel();
    });
  }

  /*
   * Return a cube by name.
   */
  getCube(cubename) {
    const cube = $.grep(this.cubes, e => e.name == cubename)[0];

    return cube;
  }

  /*
   * Get a dimension by name.
   * Accepts dimension level in the input string.
   */
  getDimension(dimension) {
    let dimname = dimension;
    if (dimension.indexOf('@') > 0) {
      dimname = dimension.split('@')[0];
    } else if (dimension.indexOf(':') > 0) {
      dimname = dimension.split(':')[0];
    }
    const dim = this._dimensions.find(ed => ed.name === dimname);
    return dim;
  }

  /*
   * Get a hierarchy by name.
   * Accepts dimension level in the input string.
   */
  getHierarchy(dimension, hierarchy) {
    const dim = this.getDimension(dimension);
    if (hierarchy) {
      return dim.getHierarchy(hierarchy);
    }
    if (dimension.indexOf('@') > 0) {
      const hierarchyName = dimension.split('@')[1].split(':')[0];
      return dim.getHierarchy(hierarchyName);
    }
    return dim.getDefaultHierarchy();
  }

  isNumDimensionValue(dimensionString) {
    const parts = this.getDimensionParts(dimensionString);
    return !!parts.hierarchy && parts.hierarchy.name === 'default' && parts.level.key === 'id';
  }

  checkIsFilterCutsValueAllowed(filter) {
    let dim;
    return filter.filters.every(cut => {
        dim = cut.dimension;
        return !this.isNumDimensionValue(dim) || !isNaN(parseInt(cut.value, 0));
      }) ? '' :
      gettext('Неверное значение измерения') + `: "${dim}"`;
  }

  getDimensionParts(dimensionString) {

    if (dimensionString === 'keyword') {
      return {
        label: gettext('Ключевое слово')
      };
    }

    const dim = this.getDimension(dimensionString);
    if (!dim) return {};
    let lev = null;
    if (dimensionString.indexOf(':') > 0) {
      const levelname = dimensionString.split(':')[1];
      lev = dim.getLevel(levelname);
    } else
      lev = dim.levels[0];

    let hie = dim.hierarchies[0];
    if (dimensionString.indexOf('@') > 0) {
      const hierarchyName = dimensionString.split('@')[1].split(':')[0];
      hie = dim.getHierarchy(hierarchyName);
    }

    return {
      dimension: dim,
      level: lev,
      hierarchy: hie,
      label: dim.label + ((lev != null && lev.label != dim.label) ?
        (': ' + lev.label) : ''),
    };

  }

  /* constnstnst
   * Get drilldown label
   */
  getDrillLabel(dimString) {
    if (dimString === 'id@default:id') return 'ID';
    return this.getDimensionParts(dimString).label;
  }

  /*
   * Get drilldown table attribute
   */

  getDrillAttr(dimString) {
    const info = this.getDimensionParts(dimString);
    return info.dimension.name + '.' + info.level.label_attribute;
  }

  getCellFilter(drill, cell) {
    const parts = this.getDimensionParts(drill);
    const infos = parts.hierarchy.readCell(cell, parts.level);
    const drilldown_level_values = [];
    const drilldown_level_labels = [];
    infos.forEach((info) => {
      drilldown_level_values.push(info.key);
      drilldown_level_labels.push(info.info.description || info.label);
    });
    const dim = drill.toString();
    let label;
    if (dim === 'agent_dialog@direction:direction') {
      label = DIALOG_DIRECTIONS[drilldown_level_values[0]];
    } else if ([
        'agent_agent@computer_name:computer_name',
        //        'agent_account@user_name:user_name',
      ].indexOf(dim) >= 0) {
      label = drilldown_level_values[2];
    } else if (dim === 'agent_time@weekday:weekday') {
      label = WEEKDAYS[drilldown_level_values[0]];
    } else {
      label = Filter.isTimeDimension(dim) ?
        Filter.labelForTime(
          Filter.levelsToTime(drilldown_level_values),
          drilldown_level_values.length,
        ) :
        drilldown_level_labels.join(' / ');
    }
    if (Filter.isTimeDimension(dim) &&
      drilldown_level_values.length > 1) {
      drilldown_level_values[1]++;
    }
    const value = drilldown_level_values.join(PATH_STRING_SEPARATOR); // inverted comma
    return {
      dimension: dim,
      value: value,
      label: label,
    };
  }

  getCellLabel(drill, cell) {
    const filter = this.getCellFilter(drill, cell);
    if (!filter.label) {
      return gettext('Значение не указано');
    }
    if (filter.dimension === 'agent_agent@last_report:last_report') {
      return gettext(filter.label);
    }
    return filter.label;
  }

  getCellWithLabel(drill, cell) {
    const filter = this.getCellFilter(drill, cell);
    cell.cellLabel = filter.label;
    cell.isEmptyLabel = !cell.cellLabel;
    if (cell.isEmptyLabel) {
      cell.cellLabel = gettext('Значение не указано');
    } else if (filter.dimension === 'agent_agent@last_report:last_report') {
        cell.cellLabel = gettext(filter.label);
    }
    return cell;
  }

}

export function buildModel(model) {
  Object.setPrototypeOf(model, Model.prototype);
  model.buildModel();
  return model;
}



// WEBPACK FOOTER //
// ./src/common/model.js